import { Grid, Paper } from "@material-ui/core";
import React from "react";
import ContentPrivate from "../../../components/ScheduleList/ContentPrivate";

export default function ScheduleListPrivate() {
    return (
        <Paper className="p-2 p-lg-3">
            <Grid container spacing={2}>
                <Grid item xs={12} lg={12}>
                    <ContentPrivate />
                </Grid>
            </Grid>
        </Paper>
    );
}
